<div class="cap">
  <header class="cap-header">
    <h1>Clientes API</h1>
    <button class="cap-btn" [disabled]="ocupado" (click)="abrirInvitar()">
      <mat-icon>person_add_alt_1</mat-icon>
      Invitar cliente
    </button>
  </header>

  <p class="cap-nota">
    Acá se invita a un cliente aprobado a usar la API de tasas, se le fija el límite y se lo
    deshabilita con motivo. La llave la crea el cliente desde su propia cuenta: acá se ve su
    identificador, sus IP y su uso, y se puede revocar en emergencia (la clave privada nunca
    pasa por Aguacate). Nada se borra.
  </p>

  <div class="cap-error" *ngIf="error">{{ error }}</div>
  <div class="cap-ok" *ngIf="aviso">{{ aviso }}</div>

  <!-- ======================================================== interruptor -->
  <section class="cap-interruptor" [class.apagada]="interruptor && !interruptor.activa" aria-label="Estado de la API externa">
    <div class="cap-interruptor-info">
      <div class="cap-interruptor-titulo">
        <h2>API externa</h2>
        <span class="cap-chip" *ngIf="interruptor" [ngClass]="interruptor.activa ? 'ENCENDIDA' : 'APAGADA'">
          {{ interruptor.activa ? 'ENCENDIDA' : 'APAGADA' }}
        </span>
        <span class="cap-chip" *ngIf="!interruptor">—</span>
      </div>
      <span class="cap-sub" *ngIf="interruptor">
        Vigilante: {{ interruptor.vigilanteActivo ? 'activo' : 'inactivo' }}
        <ng-container *ngIf="interruptor.actualizadoEn || interruptor.actualizadoPor">
          · Último cambio: por {{ interruptor.actualizadoPor || '—' }}
          <ng-container *ngIf="interruptor.actualizadoEn"> el {{ interruptor.actualizadoEn | date: 'dd/MM/yy HH:mm' }}</ng-container>
        </ng-container>
      </span>
      <span class="cap-sub" *ngIf="!interruptor && !cargandoInterruptor">El backend todavía no expone <code>/interruptor</code> o falló la consulta.</span>
      <span class="cap-sub" *ngIf="cargandoInterruptor">Consultando…</span>
      <span class="cap-sub">
        Encendida: los clientes con llave pueden consultar. Apagada: todos reciben 503 en menos de un minuto; las llaves no se tocan.
      </span>
    </div>
    <div class="cap-interruptor-accion" *ngIf="interruptor">
      <button class="cap-btn" *ngIf="!interruptor.activa" [disabled]="ocupado" (click)="alternarInterruptor()">
        <mat-icon>power_settings_new</mat-icon>
        Encender
      </button>
      <button class="cap-btn peligro" *ngIf="interruptor.activa" [disabled]="ocupado" (click)="alternarInterruptor()">
        <mat-icon>power_settings_new</mat-icon>
        Apagar
      </button>
    </div>
  </section>
  <div class="cap-error" *ngIf="errorInterruptor">{{ errorInterruptor }}</div>

  <!-- ======================================================== resumen -->
  <div class="cap-resumen" role="group" aria-label="Resumen de clientes API">
    <button type="button" class="cap-tarjeta" [class.on]="tarjeta === 'habilitados'" (click)="elegirTarjeta('habilitados')" title="Invitados y activos">
      <span class="cap-tarjeta-n">{{ valorTarjeta('habilitados') ?? '—' }}</span>
      <span class="cap-tarjeta-k">Habilitados</span>
    </button>
    <button type="button" class="cap-tarjeta" [class.on]="tarjeta === 'activos'" (click)="elegirTarjeta('activos')">
      <span class="cap-tarjeta-n">{{ valorTarjeta('activos') ?? '—' }}</span>
      <span class="cap-tarjeta-k">Activos</span>
    </button>
    <button type="button" class="cap-tarjeta" [class.on]="tarjeta === 'invitados'" (click)="elegirTarjeta('invitados')">
      <span class="cap-tarjeta-n">{{ valorTarjeta('invitados') ?? '—' }}</span>
      <span class="cap-tarjeta-k">Invitados</span>
    </button>
    <button type="button" class="cap-tarjeta" [class.on]="tarjeta === 'deshabilitados'" (click)="elegirTarjeta('deshabilitados')">
      <span class="cap-tarjeta-n">{{ valorTarjeta('deshabilitados') ?? '—' }}</span>
      <span class="cap-tarjeta-k">Deshabilitados</span>
    </button>
    <button type="button" class="cap-tarjeta" [class.on]="tarjeta === 'conLlave'" (click)="elegirTarjeta('conLlave')" title="Con llave activa (filtra la página actual)">
      <span class="cap-tarjeta-n">{{ valorTarjeta('conLlave') ?? '—' }}</span>
      <span class="cap-tarjeta-k">Con llave</span>
    </button>
    <button type="button" class="cap-tarjeta ok" [class.on]="tarjeta === 'conectadosHoy'" (click)="elegirTarjeta('conectadosHoy')" title="Con llamadas OK hoy (filtra la página actual)">
      <span class="cap-tarjeta-n">{{ valorTarjeta('conectadosHoy') ?? '—' }}</span>
      <span class="cap-tarjeta-k">Conectados hoy</span>
    </button>
    <button type="button" class="cap-tarjeta mal" [class.on]="tarjeta === 'conErroresHoy'" (click)="elegirTarjeta('conErroresHoy')" title="Con rechazos hoy (filtra la página actual)">
      <span class="cap-tarjeta-n">{{ valorTarjeta('conErroresHoy') ?? '—' }}</span>
      <span class="cap-tarjeta-k">Con errores hoy</span>
    </button>
    <button type="button" class="cap-tarjeta ok" [class.on]="tarjeta === 'conSesionActiva'" (click)="elegirTarjeta('conSesionActiva')" title="Con al menos una sesión viva (filtra la página actual)">
      <span class="cap-tarjeta-n">{{ valorTarjeta('conSesionActiva') ?? '—' }}</span>
      <span class="cap-tarjeta-k">Con sesión activa</span>
    </button>
  </div>
  <p class="cap-ayuda" *ngIf="!resumen && !cargandoResumen">El resumen no está disponible todavía (el backend no expone <code>/resumen</code> o falló).</p>

  <!-- ======================================================== vista: clientes / documentación -->
  <nav class="cap-vistas" aria-label="Sección">
    <button type="button" [class.on]="vista === 'lista'" (click)="cambiarVista('lista')">Clientes</button>
    <button type="button" [class.on]="vista === 'documentacion'" (click)="cambiarVista('documentacion')">Documentación</button>
    <button type="button" class="cap-btn secundario cap-vistas-descarga" [disabled]="descargandoOpenapi" (click)="descargarOpenapi()" title="Baja la especificación OpenAPI de /integraciones/v1">
      <mat-icon>download</mat-icon>
      {{ descargandoOpenapi ? 'Descargando…' : 'Descargar OpenAPI' }}
    </button>
  </nav>
  <div class="cap-error" *ngIf="errorOpenapi">{{ errorOpenapi }}</div>

  <!-- ======================================================== documentación -->
  <ng-container *ngIf="vista === 'documentacion'">
    <!-- ------------------------------------------------ fase 3: descargas -->
    <section class="cap-doc-bloque" aria-label="Descargas de la documentación">
      <h3>Descargas</h3>
      <p class="cap-ayuda">Lo mismo que puede bajar el cliente desde su sección API, más la especificación y la colección de la API de operadores (sólo para el panel).</p>
      <div class="cap-descargas">
        <span class="cap-descargas-k">API del cliente</span>
        <div class="cap-descargas-botones">
          <button type="button" class="cap-mini" [disabled]="!!descargando" (click)="descargar('openapi')">{{ descargando === 'openapi' ? 'Descargando…' : 'OpenAPI (YAML)' }}</button>
          <button type="button" class="cap-mini" [disabled]="!!descargando" (click)="descargar('postman')">{{ descargando === 'postman' ? 'Descargando…' : 'Colección Postman' }}</button>
          <button type="button" class="cap-mini" [disabled]="!!descargando" (click)="descargar('entorno')">{{ descargando === 'entorno' ? 'Descargando…' : 'Entorno Postman' }}</button>
        </div>
        <span class="cap-descargas-k">API de operadores</span>
        <div class="cap-descargas-botones">
          <button type="button" class="cap-mini" [disabled]="!!descargando" (click)="descargar('openapiOperadores')">{{ descargando === 'openapiOperadores' ? 'Descargando…' : 'OpenAPI operadores (YAML)' }}</button>
          <button type="button" class="cap-mini" [disabled]="!!descargando" (click)="descargar('postmanOperadores')">{{ descargando === 'postmanOperadores' ? 'Descargando…' : 'Colección Postman operadores' }}</button>
          <button type="button" class="cap-mini" [disabled]="!!descargando" (click)="descargar('entornoOperadores')">{{ descargando === 'entornoOperadores' ? 'Descargando…' : 'Entorno Postman de operadores' }}</button>
        </div>
      </div>
      <div class="cap-error cap-error-descarga" *ngIf="errorDescarga">{{ errorDescarga }}</div>
    </section>

    <!-- ------------------------------------------------ fase 3: swagger (plegable, arranca plegado) -->
    <section class="cap-doc-bloque" aria-label="Especificación OpenAPI">
      <button type="button" class="cap-plegable" [attr.aria-expanded]="swaggerAbierto" (click)="alternarSwagger()">
        <mat-icon>{{ swaggerAbierto ? 'expand_less' : 'expand_more' }}</mat-icon>
        <span class="cap-plegable-titulo">Especificación OpenAPI (Swagger)</span>
        <span class="cap-sub">API del cliente y API de operadores · sólo lectura, sin «Try it out»</span>
      </button>
      <ng-container *ngIf="swaggerAbierto">
        <nav class="cap-vistas cap-vistas-swagger" aria-label="Especificación">
          <button type="button" [class.on]="swaggerPestana === 'cliente'" (click)="cambiarSwaggerPestana('cliente')">API del cliente</button>
          <button type="button" [class.on]="swaggerPestana === 'operadores'" (click)="cambiarSwaggerPestana('operadores')">API de operadores</button>
          <button type="button" class="cap-btn secundario cap-vistas-descarga" [disabled]="swaggerCargando" (click)="cargarSwagger(true)" title="Vuelve a bajar la especificación">
            <mat-icon>refresh</mat-icon>
            Actualizar
          </button>
        </nav>
        <app-swagger-viewer [yaml]="swaggerYaml" [cargando]="swaggerCargando" [error]="swaggerError"></app-swagger-viewer>
      </ng-container>
    </section>

    <div class="cap-cargando" *ngIf="cargandoDoc">Cargando documentación…</div>
    <div class="cap-error" *ngIf="errorDoc">{{ errorDoc }}</div>
    <ng-container *ngIf="documentacion && !cargandoDoc">
      <p class="cap-doc-meta">
        Versión {{ documentacion.version }}
        <ng-container *ngIf="documentacion.actualizadoEn"> · actualizada el {{ documentacion.actualizadoEn | date: 'dd/MM/yyyy' }}</ng-container>
        · es la misma guía que ve el cliente en su sección API.
      </p>
      <article class="cap-doc" [innerHTML]="documentacion.html"></article>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="vista === 'lista'">
  <!-- ======================================================== filtros -->
  <div class="cap-filtros">
    <input
      aria-label="Buscar clientes API"
      type="search"
      placeholder="Buscar por correo o nombre"
      [ngModel]="q"
      (ngModelChange)="cambioQ($event)"
      (keyup.enter)="cargar(1)"
    />
    <select aria-label="Filtrar por estado" [(ngModel)]="estado" (change)="tarjeta = null; cargar(1)">
      <option value="">Todos los estados</option>
      <option value="INVITADO">Invitado</option>
      <option value="ACTIVO">Activo</option>
      <option value="DESHABILITADO">Deshabilitado</option>
    </select>
    <button class="cap-btn secundario" [disabled]="cargando" (click)="cargar(1)">Buscar</button>
    <button class="cap-btn secundario" [disabled]="cargando || refrescando" (click)="actualizar()" title="Recarga la lista y el resumen; además se actualiza solo cada minuto mientras la pestaña está visible">
      <mat-icon>refresh</mat-icon>
      Actualizar
    </button>
    <span class="cap-actualizado" *ngIf="actualizadoEn">
      {{ refrescando ? 'Actualizando…' : 'Actualizado ' + haceCuanto(actualizadoEn) }}
    </span>
  </div>

  <div class="cap-cargando" *ngIf="cargando">Cargando…</div>

  <ng-container *ngIf="!cargando">
    <div class="cap-vacio" *ngIf="!items.length">
      No hay clientes API{{ q || estado ? ' que coincidan' : ' todavía' }}.
    </div>
    <div class="cap-vacio" *ngIf="items.length && !itemsVista.length">
      Ningún cliente de esta página cumple el filtro de la tarjeta.
      <button type="button" class="cap-link-mini" (click)="tarjeta = null">Quitar filtro</button>
    </div>
    <p class="cap-ayuda" *ngIf="filtroEnCliente && itemsVista.length">
      Filtro aplicado sobre la página actual ({{ itemsVista.length }} de {{ items.length }}).
      <button type="button" class="cap-link-mini" (click)="tarjeta = null">Quitar filtro</button>
    </p>

    <div class="cap-tabla-wrap" *ngIf="itemsVista.length">
      <table class="cap-tabla">
        <thead>
          <tr>
            <th>
              <button type="button" class="cap-th-orden" (click)="ordenarPor('cliente')">Cliente <span>{{ flechaOrden('cliente') }}</span></button>
            </th>
            <th>
              <button type="button" class="cap-th-orden" (click)="ordenarPor('estado')">Estado <span>{{ flechaOrden('estado') }}</span></button>
            </th>
            <th>
              <button type="button" class="cap-th-orden" (click)="ordenarPor('ultimoUso')">Conexión <span>{{ flechaOrden('ultimoUso') }}</span></button>
            </th>
            <th title="Sesiones vivas (login firmado, 15 min atadas a IP)">Sesión</th>
            <th>Llave</th>
            <th>Límite</th>
            <th>Invitado</th>
            <th>Activado</th>
            <th>Última verificación</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let c of itemsVista">
            <tr [class.abierta]="detalleDe === c.usuarioId">
              <td>
                <button type="button" class="cap-link" (click)="alternarDetalle(c)">
                  <span class="cap-nombre">{{ nombreDe(c) }}</span>
                </button>
                <span class="cap-sub">{{ c.email }}</span>
              </td>
              <td>
                <span class="cap-chip" [ngClass]="c.estado">{{ etiquetaEstado(c.estado) }}</span>
              </td>
              <td class="cap-conexion" [title]="tooltipConexion(c)">
                <span class="cap-semaforo" [ngClass]="claseConexion(c)">
                  <i aria-hidden="true"></i>{{ textoConexion(c) }}
                </span>
                <span class="cap-sub">{{ hoyConexion(c) }}</span>
              </td>
              <td class="cap-sesion" [title]="tooltipSesion(c)">
                <span class="cap-semaforo" [ngClass]="claseSesion(c)">
                  <i aria-hidden="true"></i>{{ textoSesion(c) }}
                </span>
                <span class="cap-sub">{{ ultimaSesionDe(c) ? 'última ' + haceCuanto(ultimaSesionDe(c)) : '—' }}</span>
              </td>
              <td class="cap-llave">
                <span class="cap-chip" [ngClass]="claseLlave(c.llave)">{{ etiquetaLlave(c.llave) }}</span>
                <ng-container *ngIf="c.llave">
                  <code class="cap-kid">{{ c.llave.kid }}</code>
                  <span class="cap-sub">IP: {{ ipsDe(c.llave) }}</span>
                  <span class="cap-sub">
                    Último uso: {{ c.llave.ultimoUsoEn ? (c.llave.ultimoUsoEn | date: 'dd/MM/yy HH:mm') : 'nunca' }}
                    · vence {{ c.llave.expiraEn ? (c.llave.expiraEn | date: 'dd/MM/yy') : '—' }}
                  </span>
                </ng-container>
              </td>
              <td class="cap-limite">
                <span class="cap-chip" *ngIf="origenLimite(c) as o" [ngClass]="o === 'personalizado' ? 'PERSONALIZADO' : 'GENERAL'">{{ o === 'personalizado' ? 'Personalizado' : 'General' }}</span>
                <span class="cap-limite-n">{{ limiteEfectivo(c) }}/min</span>
              </td>
              <td>
                {{ c.invitadoEn | date: 'dd/MM/yy HH:mm' }}
                <span class="cap-sub">{{ c.invitadoPor }}</span>
              </td>
              <td>{{ c.activadoEn ? (c.activadoEn | date: 'dd/MM/yy HH:mm') : '—' }}</td>
              <td>
                <ng-container *ngIf="c.ultimaVerificacionEn; else sinVerificar">
                  {{ c.ultimaVerificacionEn | date: 'dd/MM/yy HH:mm' }}
                  <span class="cap-sub">{{ verificacionDe(c) }}</span>
                </ng-container>
                <ng-template #sinVerificar>—</ng-template>
              </td>
              <td class="cap-acciones">
                <button class="cap-mini" [disabled]="ocupado" (click)="abrirConfigurar(c)" title="Configurar límite, llaves y nota">
                  Configurar
                </button>
                <button
                  class="cap-mini peligro"
                  *ngIf="c.estado !== 'DESHABILITADO'"
                  [disabled]="ocupado"
                  (click)="deshabilitar(c)"
                >
                  Deshabilitar
                </button>
                <button
                  class="cap-mini"
                  *ngIf="c.estado === 'DESHABILITADO'"
                  [disabled]="ocupado"
                  (click)="rehabilitar(c)"
                >
                  Rehabilitar
                </button>
                <button
                  class="cap-mini"
                  *ngIf="c.estado !== 'DESHABILITADO'"
                  [disabled]="ocupado"
                  (click)="reenviarCorreo(c)"
                  title="Reenviar el correo de habilitación"
                >
                  Reenviar correo
                </button>
                <button
                  class="cap-mini peligro"
                  *ngIf="puedeRevocarLlave(c)"
                  [disabled]="ocupado"
                  (click)="revocarLlave(c)"
                  title="Revocar la llave vigente del cliente (emergencia)"
                >
                  Revocar llave
                </button>
              </td>
            </tr>

            <!-- ============================================ detalle -->
            <tr class="cap-detalle-fila" *ngIf="detalleDe === c.usuarioId">
              <td colspan="10">
                <div class="cap-cargando" *ngIf="cargandoDetalle">Cargando detalle…</div>
                <div class="cap-detalle" *ngIf="detalle && !cargandoDetalle">
                  <div class="cap-datos">
                    <div><span class="cap-k">Usuario</span><span>#{{ detalle.usuarioId }}</span></div>
                    <div><span class="cap-k">Máx. llaves</span><span>{{ detalle.maxLlaves }}</span></div>
                    <div><span class="cap-k">Límite</span><span>{{ limiteDe(detalle) }}</span></div>
                    <div *ngIf="detalle.nota"><span class="cap-k">Nota</span><span>{{ detalle.nota }}</span></div>
                    <div *ngIf="detalle.deshabilitadoEn">
                      <span class="cap-k">Deshabilitado</span>
                      <span>
                        {{ detalle.deshabilitadoEn | date: 'dd/MM/yy HH:mm' }} por {{ detalle.deshabilitadoPor || '—' }}
                        <ng-container *ngIf="detalle.motivo"> · {{ detalle.motivo }}</ng-container>
                      </span>
                    </div>
                  </div>

                  <h4>Conexión</h4>
                  <div class="cap-datos">
                    <div>
                      <span class="cap-k">Estado</span>
                      <span class="cap-semaforo" [ngClass]="claseConexion(detalle)"><i aria-hidden="true"></i>{{ textoConexion(detalle) }}</span>
                    </div>
                    <div>
                      <span class="cap-k">Último OK</span>
                      <span>{{ detalle.conexion?.ultimoOkEn ? (detalle.conexion?.ultimoOkEn | date: 'dd/MM/yy HH:mm') : '—' }}</span>
                    </div>
                    <div>
                      <span class="cap-k">Último fallo</span>
                      <span>
                        <ng-container *ngIf="detalle.conexion?.ultimoFalloEn; else sinFallo">
                          {{ detalle.conexion?.ultimoFalloEn | date: 'dd/MM/yy HH:mm' }}
                          <ng-container *ngIf="detalle.conexion?.ultimoFalloCodigo"> · <code>{{ detalle.conexion?.ultimoFalloCodigo }}</code></ng-container>
                          <ng-container *ngIf="detalle.conexion?.ultimoFalloIp"> · IP {{ detalle.conexion?.ultimoFalloIp }}</ng-container>
                        </ng-container>
                        <ng-template #sinFallo>—</ng-template>
                      </span>
                    </div>
                    <div>
                      <span class="cap-k">Hoy</span>
                      <span>{{ detalle.conexion ? detalle.conexion.llamadasHoy + ' ok / ' + detalle.conexion.rechazadasHoy + ' rechazadas' : '—' }}</span>
                    </div>
                    <div>
                      <span class="cap-k">Sesiones activas</span>
                      <span class="cap-semaforo" [ngClass]="claseSesion(detalle)"><i aria-hidden="true"></i>{{ textoSesion(detalle) }}</span>
                    </div>
                    <div>
                      <span class="cap-k">Última sesión</span>
                      <span>{{ ultimaSesionDe(detalle) ? (ultimaSesionDe(detalle) | date: 'dd/MM/yy HH:mm') : '—' }}</span>
                    </div>
                  </div>
                  <div class="cap-acciones-detalle" *ngIf="detalle.llave">
                    <button type="button" class="cap-mini" [disabled]="cargandoUso" (click)="cargarUsoDetalle(detalle)">
                      {{ usoDetalle ? 'Actualizar uso de la llave' : 'Ver uso de la llave (7 días)' }}
                    </button>
                  </div>
                  <div class="cap-cargando" *ngIf="cargandoUso">Cargando uso…</div>
                  <div class="cap-error" *ngIf="errorUso">{{ errorUso }}</div>
                  <ng-container *ngIf="usoDetalle && !cargandoUso">
                    <div class="cap-vacio" *ngIf="!usoDetalle.length">Sin llamadas en los últimos 7 días.</div>
                    <div class="cap-tabla-wrap interna" *ngIf="usoDetalle.length">
                      <table class="cap-tabla">
                        <thead>
                          <tr>
                            <th>Día</th>
                            <th>Ruta</th>
                            <th class="num">OK</th>
                            <th class="num">401</th>
                            <th class="num">403</th>
                            <th class="num">429</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let f of usoDetalle">
                            <td>{{ f.dia | date: 'dd/MM/yy' }}</td>
                            <td><code>{{ f.ruta }}</code></td>
                            <td class="num">{{ f.ok | number }}</td>
                            <td class="num" [class.mal]="f.http401">{{ f.http401 | number }}</td>
                            <td class="num" [class.mal]="f.http403">{{ f.http403 | number }}</td>
                            <td class="num" [class.mal]="f.http429">{{ f.http429 | number }}</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colspan="2">Total</td>
                            <td class="num">{{ totalUso('ok') | number }}</td>
                            <td class="num">{{ totalUso('http401') | number }}</td>
                            <td class="num">{{ totalUso('http403') | number }}</td>
                            <td class="num">{{ totalUso('http429') | number }}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </ng-container>

                  <h4>Llave</h4>
                  <div class="cap-vacio" *ngIf="!detalle.llave">El cliente todavía no creó su llave.</div>
                  <div class="cap-datos" *ngIf="detalle.llave">
                    <div>
                      <span class="cap-k">Identificador (kid)</span>
                      <span><code class="cap-kid">{{ detalle.llave.kid }}</code></span>
                    </div>
                    <div>
                      <span class="cap-k">Estado</span>
                      <span><span class="cap-chip" [ngClass]="claseLlave(detalle.llave)">{{ etiquetaLlave(detalle.llave) }}</span></span>
                    </div>
                    <div *ngIf="detalle.llave.nombre"><span class="cap-k">Nombre</span><span>{{ detalle.llave.nombre }}</span></div>
                    <div><span class="cap-k">IPs permitidas</span><span>{{ ipsDe(detalle.llave) }}</span></div>
                    <div>
                      <span class="cap-k">Último uso</span>
                      <span>
                        {{ detalle.llave.ultimoUsoEn ? (detalle.llave.ultimoUsoEn | date: 'dd/MM/yy HH:mm') : 'Nunca' }}
                        <ng-container *ngIf="detalle.llave.ultimoUsoIp"> desde {{ detalle.llave.ultimoUsoIp }}</ng-container>
                      </span>
                    </div>
                    <div *ngIf="detalle.llave.creadaEn"><span class="cap-k">Creada</span><span>{{ detalle.llave.creadaEn | date: 'dd/MM/yy HH:mm' }}</span></div>
                    <div><span class="cap-k">Vence</span><span>{{ detalle.llave.expiraEn ? (detalle.llave.expiraEn | date: 'dd/MM/yy') : '—' }}</span></div>
                    <div *ngIf="detalle.llave.revocadaEn">
                      <span class="cap-k">Revocada</span>
                      <span>
                        {{ detalle.llave.revocadaEn | date: 'dd/MM/yy HH:mm' }}
                        <ng-container *ngIf="detalle.llave.motivoRevocacion"> · {{ detalle.llave.motivoRevocacion }}</ng-container>
                      </span>
                    </div>
                  </div>
                  <div class="cap-acciones-detalle" *ngIf="puedeRevocarLlave(detalle)">
                    <button class="cap-mini peligro" [disabled]="ocupado" (click)="revocarLlave(detalle)">Revocar llave</button>
                  </div>

                  <h4>Eventos</h4>
                  <div class="cap-vacio" *ngIf="!detalle.eventos?.length">Sin eventos.</div>
                  <div class="cap-tabla-wrap interna" *ngIf="detalle.eventos?.length">
                    <table class="cap-tabla">
                      <thead>
                        <tr>
                          <th>Fecha</th>
                          <th>Evento</th>
                          <th>Quién</th>
                          <th>IP</th>
                          <th>Detalle</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let ev of detalle.eventos">
                          <td>{{ ev.createdAt | date: 'dd/MM/yy HH:mm' }}</td>
                          <td>{{ etiquetaEvento(ev.tipo) }}</td>
                          <td>{{ ev.actor }}</td>
                          <td>{{ ev.ip || '—' }}</td>
                          <td class="cap-detalle-json">{{ detalleEvento(ev.detalle) || '—' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="cap-paginado" *ngIf="total > 0">
      <span class="cap-paginado-rango">{{ rangoVisible }} clientes</span>
      <label class="cap-paginado-tamano">
        Por página
        <select aria-label="Clientes por página" [ngModel]="porPagina" (ngModelChange)="cambiarTamano($event)">
          <option *ngFor="let n of tamanosPagina" [ngValue]="n">{{ n }}</option>
        </select>
      </label>
      <div class="cap-paginado-botones">
        <button [disabled]="page <= 1 || cargando" (click)="cargar(1)" title="Primera página">«</button>
        <button [disabled]="page <= 1 || cargando" (click)="cargar(page - 1)">Anterior</button>
        <span>{{ page }} de {{ totalPaginas() }}</span>
        <button [disabled]="page >= totalPaginas() || cargando" (click)="cargar(page + 1)">Siguiente</button>
        <button [disabled]="page >= totalPaginas() || cargando" (click)="cargar(totalPaginas())" title="Última página">»</button>
      </div>
    </div>
  </ng-container>
  </ng-container>
</div>

<!-- ============================================================ diálogo: invitar -->
<div class="cap-velo" *ngIf="invitando" (click)="cerrarInvitar()">
  <div class="cap-dialogo" role="dialog" aria-modal="true" aria-label="Invitar cliente a la API" (click)="$event.stopPropagation()">
    <header class="cap-dialogo-head">
      <h2>Invitar cliente a la API</h2>
      <button type="button" class="cap-cerrar" aria-label="Cerrar" [disabled]="ocupado" (click)="cerrarInvitar()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <!-- paso 1: buscar -->
    <ng-container *ngIf="!elegido">
      <label class="cap-label" for="cap-busqueda">Buscar cliente aprobado</label>
      <input
        id="cap-busqueda"
        class="cap-input"
        type="search"
        autocomplete="off"
        placeholder="Correo, nombre, apellido o documento (mínimo 3 letras)"
        [ngModel]="busqueda"
        (ngModelChange)="cambioBusqueda($event)"
      />
      <p class="cap-ayuda">Solo aparecen como elegibles los clientes aprobados con el correo verificado.</p>

      <div class="cap-error" *ngIf="errorAlta">{{ errorAlta }}</div>
      <div class="cap-cargando" *ngIf="buscando">Buscando…</div>

      <ul class="cap-candidatos" *ngIf="!buscando && candidatos.length">
        <li *ngFor="let u of candidatos" [class.no-elegible]="!u.elegible">
          <div class="cap-candidato-datos">
            <span class="cap-nombre">{{ nombreDe(u) }}</span>
            <span class="cap-sub">{{ u.email }} · {{ u.tipoId }} {{ u.numeroId }}</span>
            <span class="cap-causas" *ngIf="!u.elegible && u.causas?.length">{{ u.causas.join(' · ') }}</span>
            <span class="cap-causas" *ngIf="!u.elegible && !u.causas?.length">No elegible</span>
            <span class="cap-causas" *ngIf="u.elegible && u.yaEsClienteApi">Ya es cliente API{{ u.estadoClienteApi ? ' (' + u.estadoClienteApi + ')' : '' }}</span>
          </div>
          <button class="cap-mini" *ngIf="u.elegible && !u.yaEsClienteApi" (click)="elegir(u)">Elegir</button>
        </li>
      </ul>
      <div class="cap-vacio" *ngIf="!buscando && busquedaHecha && !candidatos.length">
        Ningún cliente coincide.
      </div>
    </ng-container>

    <!-- paso 2: configurar -->
    <ng-container *ngIf="elegido">
      <div class="cap-elegido">
        <div>
          <span class="cap-nombre">{{ nombreDe(elegido) }}</span>
          <span class="cap-sub">{{ elegido.email }} · {{ elegido.tipoId }} {{ elegido.numeroId }}</span>
        </div>
        <button type="button" class="cap-mini" [disabled]="ocupado" (click)="volverABuscar()">Cambiar</button>
      </div>

      <ng-container
        *ngTemplateOutlet="formulario; context: { $implicit: formAlta, prefijo: 'alta' }"
      ></ng-container>

      <div class="cap-error" *ngIf="errorAlta">
        {{ errorAlta }}
        <ul class="cap-causas-lista" *ngIf="causasAlta.length">
          <li *ngFor="let causa of causasAlta">{{ causa }}</li>
        </ul>
      </div>

      <footer class="cap-dialogo-pie">
        <button class="cap-btn secundario" [disabled]="ocupado" (click)="cerrarInvitar()">Cancelar</button>
        <button class="cap-btn" [disabled]="ocupado || !formularioValido(formAlta)" (click)="confirmarAlta()">
          Invitar
        </button>
      </footer>
    </ng-container>
  </div>
</div>

<!-- ============================================================ diálogo: configurar -->
<div class="cap-velo" *ngIf="configurando" (click)="cerrarConfigurar()">
  <div class="cap-dialogo" role="dialog" aria-modal="true" aria-label="Configurar cliente API" (click)="$event.stopPropagation()">
    <header class="cap-dialogo-head">
      <h2>Configurar</h2>
      <button type="button" class="cap-cerrar" aria-label="Cerrar" [disabled]="ocupado" (click)="cerrarConfigurar()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="cap-elegido">
      <div>
        <span class="cap-nombre">{{ nombreDe(configurando) }}</span>
        <span class="cap-sub">{{ configurando.email }}</span>
      </div>
      <span class="cap-chip" [ngClass]="configurando.estado">{{ etiquetaEstado(configurando.estado) }}</span>
    </div>

    <ng-container
      *ngTemplateOutlet="formulario; context: { $implicit: formConfig, prefijo: 'cfg' }"
    ></ng-container>

    <div class="cap-error" *ngIf="errorConfig">{{ errorConfig }}</div>

    <footer class="cap-dialogo-pie">
      <button class="cap-btn secundario" [disabled]="ocupado" (click)="cerrarConfigurar()">Cancelar</button>
      <button class="cap-btn" [disabled]="ocupado || !formularioValido(formConfig)" (click)="guardarConfiguracion()">
        Guardar
      </button>
    </footer>
  </div>
</div>

<!-- ============================================================ formulario compartido -->
<ng-template #formulario let-f let-prefijo="prefijo">
  <!--
    Fase 2: la seleccion de productos ya no se muestra; se manda siempre
    `productos: ['*']` (el cliente ve todos). El catalogo y los metodos
    alternarTodos/alternarProducto quedan en el componente por compatibilidad.
  -->
  <p class="cap-ayuda">Acá se fija el cupo por minuto y el máximo de llaves activas (1 por diseño).</p>

  <fieldset class="cap-fieldset cap-limite-modo">
    <legend>Límite por minuto</legend>
    <label class="cap-check">
      <input type="radio" value="general" [name]="prefijo + '-limite-modo'" [(ngModel)]="f.limiteModo" />
      <span>{{ etiquetaLimiteGeneral }}</span>
    </label>
    <label class="cap-check">
      <input type="radio" value="personalizado" [name]="prefijo + '-limite-modo'" [(ngModel)]="f.limiteModo" />
      <span>Personalizado</span>
    </label>
    <div class="cap-limite-propio" *ngIf="f.limiteModo === 'personalizado'">
      <input class="cap-input" type="number" min="1" max="600" step="1" [id]="prefijo + '-limite'" aria-label="Límite personalizado por minuto" [(ngModel)]="f.limitePorMinuto" />
      <span class="cap-sub">consultas/min · de 1 a 600</span>
    </div>
    <p class="cap-ayuda" *ngIf="f.limiteModo === 'personalizado'">Solo para clientes que necesitan más cupo.</p>
  </fieldset>

  <div class="cap-campos">
    <label>
      <span class="cap-label">Máximo de llaves</span>
      <input class="cap-input" type="number" min="1" step="1" [id]="prefijo + '-llaves'" [(ngModel)]="f.maxLlaves" />
    </label>
  </div>
  <label class="cap-campo-ancho">
    <span class="cap-label">Nota (interna, opcional)</span>
    <input class="cap-input" type="text" maxlength="255" [id]="prefijo + '-nota'" [(ngModel)]="f.nota" placeholder="Para qué usa la API, quién lo pidió…" />
  </label>
</ng-template>
